/**
 * 问答相关的打点
 * - 问答详情页
 */

export default {
  /**
   * 问答详情页点击
   * @param {*} click 点击
      collect|收藏;
      praise|点赞;
      hot|热门问答;
   * @param {*} type 教程ID
   */
  detailsQaClick({ click, type }) {
    this.collect('details_qa_click', {
      click,
      type,
    });
  },

  /**
   *问答详情页展示
   * @param {*} show 展示
      details|详情页;
      0.3|问答阅读至30%;
      0.5|问答阅读至50%;
      0.9|问答阅读至90%;
      1|问答阅读至100%;
   * @param {*} type 教程ID
   */
  detailsQaShow({ show, type}) {
    this.collect('details_qa_show', {
      show,
      type,
    });
  },

  /**
   * 文章详情页结束
   * @param {*} view 页尾是否展示（改为不包含底部页尾黑块区域）
   * @param {*} time 停留时间以秒为单位进行上报
   * @param {*} type 教程ID
   */
  detailsQaEnd({ view, time, type }) {
    this.collect('details_qa_end', { view, time, type });
  },

  /**
   * 【问答列表页】
   * 页面点击事件
   *  @param {*} click
   *  firstclass|上报一级分类关键词;
      secondclass|上报二级分类关键词;
      thirdclass|上报三级分类关键词;
      default|默认;
      number|学习人数;
      time|发布时间;
      collect|收藏人数;
      @param {*} type：教程ID
   */
  listQaClick({ click, type }) {
    this.collect('list_qa_click', { click, type });
  },

  /**
   * @param {*} show：展示
   * qa|页面展示
   */
  listQaShow({ show }) {
    this.collect('list_qa_show', { show });
  }
};
